import CryptoJS from 'crypto-js';

export const encryptData = (data) => {
  const encryptionKey = localStorage.getItem('encryptionKey');
  if (!encryptionKey) {
    console.error('Encryption key not found');
    return null;
  }
  try {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), encryptionKey).toString();
    return ciphertext;
  } catch (error) {
    console.error('Encryption error:', error);
    return null;
  }
};

export const decryptData = (ciphertext) => {
  let encryptionKey = localStorage.getItem('encryptionKey');
  if (!encryptionKey) {
    encryptionKey = '1234567890123456';
  }
  try {
    const bytes  = CryptoJS.AES.decrypt(ciphertext, encryptionKey);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    //console.error('Decryption error:', error);
    return '1234';
  }
};
